export default __webpack_public_path__ + "static/screenshot-gestion-demandes-groupe-91ba274afcc4e910356271f299edf3f4.png";